export default "__VITE_ASSET__bad2071e__"